<template>
  <div class="formdata owner">
    <div class="header-container">
    <h3 id="owner_question">Sind Sie Eigentümer:in des Hauses oder liegt Ihnen eine Vollmacht vor?</h3>
</div>
    <CustomRadioGroup
        :options="ownerAnswers"
        v-model="selectedOwner"
        aria-labelledby="owner_question"
        :unique="ownerQuestion"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'owner_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>

    <button
        class="button button_yellow right"
        v-if="selectedOwner"
        @click="submit"
    >
      Weiter
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '../../stores/workflow.js';
import { ownerAnswers, ownerApi } from '@/data/ownerData.js';
import CustomRadioGroup from '@/components/CustomRadioGroup.vue';

const workflowStore = useWorkflowStore();

const getOwnerAnswerEventData = (selectedValue) => {
  const fullOwnerAnswer = ownerAnswers.find(bt => bt.value === selectedValue);

  if (fullOwnerAnswer) {
    return {
      value: selectedValue,
      apiDefinition: ownerApi,
      apiValue: fullOwnerAnswer.api,
      available: fullOwnerAnswer.available,
    };
  }
  return null;
};

const selectedOwner = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.owner || null;
  },
  set(newValue) {
    const eventData = getOwnerAnswerEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_OWNER_ANSWER',
      data: eventData,
    });
  },
});

const submit = () => {
  if (selectedOwner.value) {
    const eventData = getOwnerAnswerEventData(selectedOwner.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};
</script>

